/*
 * PatternCell.ts
 */
export class PatternCell {
    constructor(value) {
        this.value = value;
    }
    setValue(value) {
        this.value = value;
    }
    getValue() {
        return this.value;
    }
    isActive() {
        return this.value == PatternCell.ACTIVE;
    }
}
PatternCell.INACTIVE = 0;
PatternCell.ACTIVE = 1;
//# sourceMappingURL=PatternCell.js.map